export default "__VITE_ASSET__CidkzI11__"